import { createSlice } from "@reduxjs/toolkit"
import {
  getAllGiftCardCategories,
  getGiftCardCategoryDetails,
  addGiftCardCategory,
  updateGiftCardCategory,
  deleteGiftCardCategory,
  getAllGiftCardCategoriesWithoutPagination,
} from "store/actions/giftCardCategoriesAction"

const initialState = {
  loading: false,
  isLoading: false,
  totalCount: 0,
  totalPages: 0,
  currentPage: 1,
  itemsPerPage: 10,
  categories: [],
  categoryDetails: {},
}

const giftCardCategoriesSlice = createSlice({
  name: "giftCardCategories",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL
    builder
      .addCase(getAllGiftCardCategories.pending, state => {
        state.loading = true
      })
      .addCase(getAllGiftCardCategories.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.categories = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllGiftCardCategories.rejected, state => {
        state.loading = false
      })

    // GET ALL WITHOUT PAGINATION
    builder
      .addCase(getAllGiftCardCategoriesWithoutPagination.pending, state => {
        state.loading = true
      })
      .addCase(getAllGiftCardCategoriesWithoutPagination.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.categories = data
        }
      })
      .addCase(getAllGiftCardCategoriesWithoutPagination.rejected, state => {
        state.loading = false
      })

    // GET DETAILS
    builder
      .addCase(getGiftCardCategoryDetails.pending, state => {
        state.loading = true
        state.categoryDetails = {}
      })
      .addCase(getGiftCardCategoryDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.categoryDetails = data
        }
      })
      .addCase(getGiftCardCategoryDetails.rejected, state => {
        state.loading = false
      })

    // ADD
    builder
      .addCase(addGiftCardCategory.pending, state => {
        state.isLoading = true
      })
      .addCase(addGiftCardCategory.fulfilled, state => {
        state.isLoading = false
      })
      .addCase(addGiftCardCategory.rejected, state => {
        state.isLoading = false
      })

    // UPDATE
    builder
      .addCase(updateGiftCardCategory.pending, state => {
        state.isLoading = true
      })
      .addCase(updateGiftCardCategory.fulfilled, state => {
        state.isLoading = false
      })
      .addCase(updateGiftCardCategory.rejected, state => {
        state.isLoading = false
      })

    // DELETE
    builder
      .addCase(deleteGiftCardCategory.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteGiftCardCategory.fulfilled, (state, action) => {
        const { status } = action.payload || {}
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.categories = state.categories.filter(item => item.id !== id)
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteGiftCardCategory.rejected, state => {
        state.isLoading = false
      })
  },
})

export default giftCardCategoriesSlice.reducer 